import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import axiosConstants from "./axiosConstants";

const settings = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true,
    "X-interswitch-domain": "ISW",
    "X-XSRF-TOKEN": axiosConstants.XSRF,
  },
};

export const baseURL =
  process.env.NODE_ENV === "production"
    ? "kms-portlet/"
    : "https://isw-key-management-service.k8.isw.la/isw-kms/api/v1";
const instance = axios.create({ ...settings, baseURL });

if (process.env.NODE_ENV !== "production") {
  instance.defaults.headers.common.Authorization =
    "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJsYXN0TmFtZSI6IklmZWFueWktT2tvcm9ua3dvIiwiZmlyc3RMb2dpbiI6ZmFsc2UsInVzZXJfbmFtZSI6IlRvY2hpLk9rb3Jvbmt3byIsIm1vYmlsZU5vIjoiMjM0ODEzMzIxMzE5OCIsImNsaWVudF9pZCI6InBvc3RtYW4iLCJmaXJzdE5hbWUiOiJUb2NoaSIsImVtYWlsVmVyaWZpZWQiOnRydWUsImF1ZCI6WyJpbmNvZ25pdG8iLCJjYWVzYXIiLCJ0cmFuc2Zlci1zZXJ2aWNlLWNvcmUiLCJpc3ctcGF5bWVudGdhdGV3YXkiLCJ0cmFuc2Zlci1zZXJ2aWNlLXBvcnRsZXQiLCJwYXNzcG9ydCIsImlzdy1wb3N0LW9mZmljZSIsImlzdy1jb2xsZWN0aW9ucyIsInZhdWx0IiwiaXN3LWNvcmUiLCJpc3ctcG9ydGFsIiwib3BzLWNlbnRyYWwiLCJpc3ctcGFwc3MiLCJ3YWxsZXQiLCJyZWN1cnJlbnQtYmlsbGluZy1hcGkiLCJoaW1zLXBvcnRsZXQiLCJ0cy1uYW1lLWVucXVpcnkiLCJuaWJzcy1pZHJpcy1jb3B5LXNldHRpbmdzIiwiY2FyZGxlc3Mtc2VydmljZSIsInBvc3RjYXJkLWFwaSIsImFyYml0ZXIiLCJyZWZlcnJhbC1zZXJ2aWNlLWFwaSIsInByb2plY3QteC1tZXJjaGFudCIsInRyYW5zZmVyLXNlcnZpY2UtYWRtaW4iLCJ3ZWJwYXktcG9ydGxldCIsInNhZmV0b2tlbi1hZG1pbi1hcGkiLCJpc3ctbGVuZGluZy1zZXJ2aWNlIl0sImF1dGhlbnRpY2F0ZWRCeSI6IkxEQVAiLCJzY29wZSI6WyJwcm9maWxlIl0sImV4cCI6MzMyMzE1MzM5MCwibW9iaWxlTm9WZXJpZmllZCI6dHJ1ZSwiY2xpZW50X25hbWUiOiJQb3N0bWFuIiwianRpIjoiY2MwNjkxMWItNjliMS00NDllLTg0ZmYtODU0Njg2NzRiZDZiIiwiZW1haWwiOiJUb2NoaS5JZmVhbnlpLU9rb3Jvbmt3b0BpbnRlcnN3aXRjaGdyb3VwLmNvbSIsInBhc3Nwb3J0SWQiOiIyOEMwNDlEMy1FQ0IzLTM4Q0MtQTUxOC04OUYyQUU4RTBDQjQifQ.AJLwFaRD5W3ycLa1_uTo1AclauWPx3AqG62gWiwf7XHUtu1Y-yh631bkD9o1CVzc9cDlGWIJ2iovyFV28CpSmtF44-BH5dOfc8Nat0MgzK7PTqefmBbIMVT0M_5vLBU5iX8iqQ25DfuaoUu3vY7VeLeZDCzSsOwGdxLnfrCYLhcow1Ia3nqb4XqrMpQrXacMPsedFgro4fZ_VXXKxZNgHhRuiaIJMnm-DWfq35j0Ah3QbPiIhELUtg_qvqrBOvllZSRj3ISU_zF7SGuC2ldfp1K-P6oiU-U8USgn1yIzvwqYlVROP8k3YfT7OIjDlCNVmjTX9KWP3P7lIsUIGIBhWQ";
}

interface AxiosInstanceType {
  get: (url: string, request?: AxiosRequestConfig) => Promise<AxiosResponse>;
  post: (
    url: string,
    data?: any,
    request?: AxiosRequestConfig
  ) => Promise<AxiosResponse>;
  put: (
    url: string,
    data?: any,
    request?: AxiosRequestConfig
  ) => Promise<AxiosResponse>;
  patch: (
    url: string,
    data?: any,
    request?: AxiosRequestConfig
  ) => Promise<AxiosResponse>;
  delete: (url: string, request?: AxiosRequestConfig) => Promise<AxiosResponse>;
}

const getAxiosInstance = (_instance: AxiosInstance) => {
  return {
    async get(url: string, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.get(url, config);
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async post(url: string, data: any, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.post(url, data, config);
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async put(url: string, data: any, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.put(url, data, config);
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async patch(url: string, data: any, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.patch(url, data, config);
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async delete(url: string, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.delete(url, config);
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  };
};

export const axiosInstance: AxiosInstanceType = getAxiosInstance(instance);
